import { Component, Input, OnInit, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';

import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { CoreMenuService } from '@core/components/core-menu/core-menu.service';

@Component({
	selector: '[core-menu]',
	templateUrl: './core-menu.component.html',
	styleUrls: ['./core-menu.component.scss'],
	encapsulation: ViewEncapsulation.None,
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class CoreMenuComponent implements OnInit {
	currentUser: any;

	@Input()
	layout = 'vertical';

	@Input()
	menu: any;

	// Private
	private _unsubscribeAll: Subject<any>;

	/**
	 *
	 * @param {CoreMenuService} _coreMenuService
	 */
	constructor(private _coreMenuService: CoreMenuService) {
		// Set the private defaults
		this._unsubscribeAll = new Subject();
	}

	// Lifecycle hooks
	// -----------------------------------------------------------------------------------------------------

	/**
	 * On init
	 */
	ngOnInit(): void {
		// Set the menu either from the input or from the service
		// Verifica se c'è un menu corrente prima di chiamare getCurrentMenu
		if (!this.menu && this._coreMenuService['_currentMenuKey']) {
			this.menu = this._coreMenuService.getCurrentMenu();
		}

		// Subscribe to the current menu changes
		this._coreMenuService.onMenuChanged.pipe(takeUntil(this._unsubscribeAll)).subscribe(() => {
			this.currentUser = this._coreMenuService.currentUser;

			// Load menu solo se c'è un menu corrente impostato
			if (this._coreMenuService['_currentMenuKey']) {
				this.menu = this._coreMenuService.getCurrentMenu();
			}
		});
	}
}
